<script setup>
import { RouterView } from 'vue-router'
import { toastState } from '@/utils/toast'
</script>

<template>
  <v-app class="app-shell">
    <v-main class="main-shell">
      <RouterView />
    </v-main>

    <!-- Global Toast Snackbar -->
    <v-snackbar
      v-model="toastState.show"
      :color="toastState.color"
      :timeout="toastState.timeout"
      :location="toastState.location"
    >
      {{ toastState.message }}
    </v-snackbar>
  </v-app>
</template>

<style scoped>
.app-shell {
  width: 100vw;
  min-height: 100vh;
}

.main-shell {
  padding: 0;
  width: 100%;
  min-height: 100vh;
}
</style>

